import { schema } from "normalizr";

export class CategorySchema extends schema.Entity {
  constructor() {
    super("category", {}, { idAttribute: "_id" });
  }
}
